import React, { useEffect, useState } from 'react';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import PropTypes from 'prop-types';
import TimeOffViewList from './TimeOffViewList';
import { getFacilityDetails } from 'nursd-dashboard/api/facilityTable';
import { Card } from 'react-bootstrap';
import { getNurseDetails } from 'nursd-dashboard/api/nurseTable';
import { getAllTimeOffLocation } from 'nursd-dashboard/api/timeSheet';

const TimeOff = () => {
  const { authToken, location, organization } = useAuth();
  const [timeOff, setTimeOff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const checkUser = async (authToken, location, organization) => {
    setLoading(true);
    try {
      await getAllTimeOffLocation(
        authToken,
        location,
        organization,
        'Completed'
      ).then(async res => {
        let array = [];
        // console.log(res);
        for (let i = 0; i < res.length; i++) {
          const item = res[i];
          const nurseData = await getNurseDetails(
            authToken,
            item?.nurseTableID
          );
          if (item?.approvedManager) {
            const facilityData = await getFacilityDetails(
              authToken,
              item?.approvedManager
            );
            let obj = {
              ...item,
              approvedManagerData: facilityData,
              nurseData: nurseData
            };
            array.push(obj);
          } else {
            let obj = {
              ...item,
              approvedManagerData: undefined,
              nurseData: nurseData
            };
            array.push(obj);
          }
        }
        setTimeOff(
          array.sort((a, b) => new Date(b?.startDate) - new Date(a?.startDate))
        );
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (location) {
      checkUser(authToken, location, organization);
    }
  }, [location, organization]);

  return (
    <>
      {loading ? (
        <Card>
          <Card.Header>
            <h5 className="mb-0">Loading...</h5>
          </Card.Header>
        </Card>
      ) : (
        <TimeOffViewList
          data={timeOff}
          nurseId={''}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      )}
    </>
  );
};

TimeOff.propTypes = {
  nurseId: PropTypes.number
};

export default TimeOff;
